function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { advListApi, advDeleteApi, advSetStatusApi, advCreateApi, advUpdateApi } from '@/api/ads/adv';
import { appletListApi } from '@/api/operation/applet';
import RightToolbar from "@/components/RightToolbar/index.vue";
import AdCode from './components/AdCode.vue';
import { typeOptions, platformOptions, defaultFormData, formRules } from './enums';
export default {
  components: {
    RightToolbar: RightToolbar,
    AdCode: AdCode
  },
  data: function data() {
    return {
      loading: false,
      platformOptions: platformOptions,
      typeOptions: typeOptions,
      dialogVisible: false,
      form: JSON.parse(JSON.stringify(defaultFormData)),
      formRules: formRules,
      appList: [],
      adCode: {
        id: '',
        adType: undefined,
        platform: undefined,
        show: false
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '广告类型',
        prop: 'adType',
        defaultValue: '',
        type: 'select',
        options: {
          list: typeOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'adInfo',
        visible: true,
        label: "\u5E7F\u544A\u540D",
        width: 160
      }, {
        key: 'adType',
        visible: true,
        label: "\u5E7F\u544A\u7C7B\u578B",
        width: 90,
        formatter: 'tag'
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 80
      }, {
        key: 'platform',
        visible: true,
        label: "\u5E73\u53F0",
        width: 160,
        formatter: 'tag'
      }, {
        key: 'createTime',
        visible: true,
        label: "\u66F4\u65B0\u65F6\u95F4",
        width: 160
      }, {
        key: 'remark',
        visible: true,
        label: "\u5907\u6CE8",
        width: 160
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), this.params);
      return advListApi(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'adType') {
        var target = typeOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      if (key === 'platform') {
        var _target = platformOptions.find(function (item) {
          return item.value === value;
        });
        return _target && _target[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return advDeleteApi(row.id);
      }).then(function () {
        _this2.getList();
        _this2.$modal.msgSuccess('删除成功');
      });
    },
    closeEdit: function closeEdit() {
      this.dialogVisible = false;
      this.refreshList();
    },
    initForm: function initForm(data) {
      for (var key in data) {
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = data[key];
        }
      }
    },
    //添加广告
    handleAdd: function handleAdd() {
      this.initForm(defaultFormData);
      this.dialogVisible = true;
    },
    //编辑广告
    handleEdit: function handleEdit(row) {
      this.initForm(row);
      this.dialogVisible = true;
    },
    // 修改状态
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      var params = {
        id: row.id,
        status: row.status
      };
      this.loading = true;
      advSetStatusApi(params).then(function (res) {
        _this3.loading = false;
        _this3.$message.success('更新状态成功');
      }).catch(function () {
        _this3.loading = false;
        _this3.$message.error('更新状态失败');
        row.status = row.status ? 0 : 1;
      });
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.form.validate(function (valid, obj) {
        if (valid) {
          _this4.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this4.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this5 = this;
      this.loading = true;
      var data = _objectSpread({}, this.form);
      var func = data.id ? advUpdateApi : advCreateApi;
      func(data).then(function (res) {
        _this5.$message.success('保存成功');
        setTimeout(function () {
          _this5.closeEdit();
        }, 500);
        _this5.loading = false;
      }).catch(function (res) {
        _this5.loading = false;
      });
    },
    handleAdCode: function handleAdCode(row) {
      var _this6 = this;
      this.adCode.id = row.id;
      this.adCode.adType = row.adType;
      this.adCode.platform = row.platform;
      this.$nextTick(function () {
        _this6.adCode.show = true;
      });
    }
  }
};